import alt from 'components/Dispatcher';
import generateAsyncActions from 'utils/generateAsyncActions';
import AdminFilterWordProfileSource from 'sources/admin/AdminFilterWordProfileSource';

class AdminFilterWordProfileActions {
  constructor() {
    this.generateActions(
      ...generateAsyncActions(
        'associateProfileWithTeam',
        'associateProfileWithDepartment',
        'cloneFilterWord',
        'createFilterWord',
        'createProfile',
        'deleteFilterWord',
        'dissociateDepartmentProfile',
        'dissociateTeamProfile',
        'fetchAccountProfiles',
        'fetchDepartments',
        'fetchTopic',
        'fetchTriggers',
        'mergeTopics',
        'updateFilterWord',
        'updateProfile'
      )
    );
  }

  associateProfileWithDepartment(filterWordProfileId, departmentId) {
    return dispatch => {
      dispatch();
      return AdminFilterWordProfileSource.associateProfileWithDepartment(
        filterWordProfileId,
        departmentId
      ).then(
        () => this.associateProfileWithDepartmentSuccess(filterWordProfileId, departmentId),
        this.associateProfileWithDepartmentError
      );
    };
  }

  associateProfileWithTeam(filterWordProfileId, departmentId, teamId) {
    return dispatch => {
      dispatch();
      return AdminFilterWordProfileSource.associateProfileWithTeam(
        filterWordProfileId,
        teamId
      ).then(
        () => this.associateProfileWithTeamSuccess(filterWordProfileId, departmentId, teamId),
        this.associateProfileWithTeamError
      );
    };
  }

  cloneFilterWord(filterWordId) {
    return dispatch => {
      dispatch();
      return AdminFilterWordProfileSource.cloneFilterWord(filterWordId).then(
        this.cloneFilterWordSuccess,
        this.cloneFilterWordError
      );
    };
  }

  createFilterWord(word) {
    return dispatch => {
      dispatch();
      return AdminFilterWordProfileSource.createFilterWord(word).then(
        this.createFilterWordSuccess,
        this.createFilterWordError
      );
    };
  }

  createProfile(profile, departmentId, teamId) {
    return dispatch => {
      const either = teamId == null ? {departmentId} : {teamId};
      dispatch();
      // backend expects exactly one of the ids,
      return AdminFilterWordProfileSource.createProfile(profile, either).then(profile => {
        // but we need both to find things in the store.
        this.createProfileSuccess(profile, departmentId, teamId, either);
      }, this.createProfileError);
    };
  }

  deleteFilterWord(filterWordId) {
    return dispatch => {
      dispatch();
      return AdminFilterWordProfileSource.deleteFilterWord(filterWordId).then(
        this.deleteFilterWordSuccess,
        this.deleteFilterWordError
      );
    };
  }

  dissociateDepartmentProfile(departmentId) {
    return dispatch => {
      dispatch();
      return AdminFilterWordProfileSource.dissociateDepartmentProfile(departmentId).then(
        // As far as the store's concerned, this looks like association, but the profileId is null.
        () => this.associateProfileWithDepartmentSuccess(null, departmentId),
        this.associateProfileWithDepartmentError
      );
    };
  }

  dissociateTeamProfile(departmentId, teamId) {
    return dispatch => {
      dispatch();
      return AdminFilterWordProfileSource.dissociateTeamProfile(teamId).then(
        // As far as the store's concerned, this looks like association, but the profileId is null.
        () => this.associateProfileWithTeamSuccess(null, departmentId, teamId),
        this.associateProfileWithTeamError
      );
    };
  }

  fetchAccountProfiles() {
    return dispatch => {
      dispatch();
      return AdminFilterWordProfileSource.fetchAccountProfiles().then(
        this.fetchAccountProfilesSuccess,
        this.fetchAccountProfilesError
      );
    };
  }

  fetchDepartments() {
    return dispatch => {
      dispatch();
      return AdminFilterWordProfileSource.fetchDepartments().then(
        this.fetchDepartmentsSuccess,
        this.fetchDepartmentsError
      );
    };
  }

  fetchTriggers(filterWordId) {
    return dispatch => {
      dispatch();
      return AdminFilterWordProfileSource.fetchTriggers(filterWordId).then(
        this.fetchTriggersSuccess,
        this.fetchTriggersError
      );
    };
  }

  mergeTopics([topicsToMerge, mergedName]) {
    return dispatch => {
      dispatch();
      return AdminFilterWordProfileSource.mergeTopics([topicsToMerge, mergedName]).then(
        this.mergeTopicsSuccess,
        this.mergeTopicsError
      );
    };
  }

  updateFilterWord(filterWord) {
    return dispatch => {
      dispatch();
      return AdminFilterWordProfileSource.updateFilterWord(filterWord).then(
        this.updateFilterWordSuccess,
        this.updateFilterWordError
      );
    };
  }

  updateProfile(profile) {
    return dispatch => {
      dispatch();
      return AdminFilterWordProfileSource.updateProfile(profile).then(
        this.updateProfileSuccess,
        this.updateProfileError
      );
    };
  }
}

export default alt.createActions(AdminFilterWordProfileActions);
